import React from "react";
import { Button, Modal } from "@telia/teddy";
import PAGES from "../../../../../../constants/pages";

interface ContinueOrderModalProps {
    onClose: () => void;
    orderRef: string;
}

const ContinueOrderModal: React.FC<ContinueOrderModalProps> = ({ onClose, orderRef }) => {
    const handleConfirm = () => {
        window.location.assign(`${PAGES.RETAILER.ORDER.CUSTOMER.URL}?order_reference=${encodeURIComponent(orderRef)}`);
    };

    return (
        <Modal open onOpenChange={() => onClose()}>
            <Modal.Overlay>
                <Modal.Content>
                    <Modal.Group variant="title">
                        <Modal.Title as="h3">Fortsette med dette ordreutkastet?</Modal.Title>
                        <Modal.Close aria-label="lukk" slot="floating" onClick={onClose} />
                    </Modal.Group>
                    Ved å fortsette vil din nåværende ordre bli erstattet med dette utkastet.
                    <Modal.Group variant="action">
                        <Modal.Close slot="content">
                            <Button variant="secondary" onClick={onClose}>
                                Avbryt
                            </Button>
                        </Modal.Close>
                        <Button variant="primary" onClick={handleConfirm}>
                            Fortsett
                        </Button>
                    </Modal.Group>
                </Modal.Content>
            </Modal.Overlay>
        </Modal>
    );
};

export default ContinueOrderModal;
